var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-layer"}),_c('span',{staticStyle:{"color":"#c62e3f","position":"absolute","top":"50%","left":"50%","z-index":"101","margin-left":"-75px","margin-top":"7px"}},[_vm._v("签署中，请勿离开此页...")]),_c('img',{attrs:{"src":require("../../assets/images/data-loading.gif")}})])
}]

export { render, staticRenderFns }